export default __webpack_public_path__ + "static/media/gitHubIcon.e9c1f8fa.png";